import { ReactComponent as AddToCompareIcon } from './add_to_compare.svg';

export default AddToCompareIcon;
